import { ApiService, GenericError} from './api-main'
import TokenService from './token-service'
import store from '../store';
import CryptoAES        from 'aes-ecb'

const TransactionService = {
    getMyTransactionList: async function(startIndex, searchLimit, id) {

        ApiService.setCustomHeader(2, TokenService.getToken(), "");

        const params = {
            startIndex       : startIndex,
            searchLimit      : searchLimit,
            version          : 1,
            createdDateStart : "",
            createdDateEnd   : ""
        }
        var url = ''
        if(id != undefined && id != ''){
            url = 'main/transaction/search?transactionId='+id
        }else{
            url = 'main/transaction/search'
        }

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return ApiService.validateResponse(response, '0506')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getMyTransactionDetails: async function(transactionId) {
        const params = {
            transactionId    : transactionId,
            startIndex       : 0,
            createdDateStart : "",
            createdDateEnd   : ""
        }
        const url = 'main/transaction/search'

        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return ApiService.validateResponse(response, '0506')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    checkWSDateFormat: function(dateString){
        if(dateString == ''){
            return dateString
        }else{
            const tempDate   = new Date(Date.parse(dateString))

            //Webservice Parameter Createdate and EndDate only accept format DD-MM-YYYY
            return (tempDate.getDate() +"-"+ (tempDate.getMonth() + 1) +"-"+ tempDate.getFullYear()).toString()
        }
    },

    getSpecialCharge: async function(deliveryMethodId, destinationCountryId) {
        const params = {
            retailAgentId           : process.env.VUE_APP_RETAIL_AGENT_ID,
            deliveryMethodId        : deliveryMethodId,
            destinationCountryId    : destinationCountryId
        }
        const url = 'main/transaction/specialcharges'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return response.data;
            //return ApiService.validateResponse(response, '2100')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getCharge: async function(destinationCountryId,deliveryMethodId,bankId,bankBranchId,countryId,transactionTypeId,couponCode, provinceId, cityId, hostAmountStr) {
        const params = {
            retailBranchId          : store.state.misc.appBranchId,
            destinationCountryId    : destinationCountryId,
            deliveryMethodId        : deliveryMethodId,
            bankId                  : bankId,
            bankBranchId            : bankBranchId,
            countryId               : countryId,
            transactionTypeId       : transactionTypeId,
            couponCode              : couponCode,
            provinceId              : provinceId,
            cityId                  : cityId,
            hostAmountStr           : hostAmountStr
        }
        const url = 'main/transaction/charges'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return response.data;
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getDiscount: async function(transactionTypeId,destinationCountryId,homeCurrencyId,hostCurrencyId,transactionCharges,couponCode,deliveryMethodId,bankTypeId, hostAmountStr) {
        const params = {
            retailBranchId              : store.state.misc.appBranchId,
            transactionTypeId           : transactionTypeId,
            destinationCountryId        : destinationCountryId,
            homeCurrencyId              : homeCurrencyId,
            hostCurrencyId              : hostCurrencyId,
            transactionCharges          : transactionCharges,
            couponCode                  : couponCode,
            deliveryMethodId            : deliveryMethodId,
            bankTypeId                  : bankTypeId,
            hostAmountStr               : hostAmountStr
        }
        const url = 'main/transaction/discount'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return response.data;
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e;
            }
        }
    },

    getDiscountList: async function(destinationCountryId) {
        const params = {
            retailBranchId              : store.state.misc.appBranchId,
            destinationCountryId        : destinationCountryId
        }
        const url = 'main/transaction/discount/coupon'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return ApiService.validateResponse(response, '1601')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getPaymentMethodList: async function(amount) {
        const url = 'main/paymentmethod/'+ process.env.VUE_APP_RETAIL_AGENT_ID
        const params = {
            amount          : amount,
            hasOtherTxn     : false
        }
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return ApiService.validateResponse(response, '4200')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getMinHostAmount: async function() {
        const url = 'main/transaction/minhostamount/retailagent/'+ process.env.VUE_APP_RETAIL_AGENT_ID
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})

            return ApiService.validateResponse(response, '3500')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getExpressMapping: async function(dmId, bankId, countryId, express) {
        const url = 'main/bank/expressmapping'

        const params = {
            dmId                    : dmId,
            bankId                  : bankId,
            countryId               : countryId,
            express                 : express
        }
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})

            return ApiService.validateResponse(response, '7502')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    createRemittance: async function(beneficiaryId,homeAmount,hostAmount,transactionCharges,couponCode,totalAmountPayable,deliveryMethodId,bankId,paymentPurpose) {
        ApiService.setHeader()
        let axiosHeader = {
            headers: {
                'Content-Type'                : 'application/json;charset=UTF-8',
                "Authorization"               : `Bearer ${TokenService.getToken()}`
            }
        };
        const url = 'main/remittance'
        const params = {
            beneficiaryId     : beneficiaryId,
            retailBranchId    : store.state.misc.appBranchId,
            homeAmount        : homeAmount,
            hostAmount        : hostAmount,
            transactionCharges: transactionCharges,
            couponCode        : couponCode,
            totalAmountPayable: totalAmountPayable,
            paymentPurpose    : paymentPurpose,
            deliveryMethodId  : deliveryMethodId,
            bankId            : bankId
        }
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customHeader(url, params, axiosHeader)
            console.log(response)
            const resTransaction = response.data;

            return resTransaction;
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getRemittance: async function(id) {
        const url = 'main/remittance/'+id
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})

            return ApiService.validateResponse(response, '0506')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    createBillPayment: async function(beneficiaryId,homeAmount,hostAmount,transactionCharges,couponCode,totalAmountPayable,deliveryMethodId,bankId,paymentPurpose) {
        ApiService.setHeader()
        let axiosHeader = {
            headers: {
                'Content-Type'                : 'application/json;charset=UTF-8',
                "Authorization"               : `Bearer ${TokenService.getToken()}`
            }
        };
        const url = 'main/billpayment'
        const params = {
            beneficiaryId     : beneficiaryId,
            retailBranchId    : store.state.misc.appBranchId,
            homeAmount        : homeAmount,
            hostAmount        : hostAmount,
            transactionCharges: transactionCharges,
            couponCode        : couponCode,
            totalAmountPayable: totalAmountPayable,
            paymentPurpose    : paymentPurpose,
            deliveryMethodId  : deliveryMethodId,
            billCorpId        : bankId
        }
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customHeader(url, params, axiosHeader)
            console.log(response)
            const resTransaction = response.data;

            return resTransaction;
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getBillPayment: async function(id) {
        const url = 'main/billpayment/'+id
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            return ApiService.validateResponse(response, '0506')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    cancelTransaction: async function(transactionId, transactionTypeId) {
        let result  = {invalid:false };
        var url = 'main/remittance'
        if(transactionTypeId == 1){
            url = 'main/billpayment'
        }
        url = url + '/' + transactionId + '/cancel?version=2'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.put(url, {})
            // console.log("canceltrxx---->" + JSON.stringify(response));
            result = response.data;
            if(result.status == "0514"){
                result.invalid = false;
            }else{
                result.invalid = true;
                result.message = "Sorry, this transaction cannot be cancelled.";
            }
            return result;
        } catch(e) {
            console.log(e)
            result.invalid = true;
            result.message = "Sorry, this transaction cannot be cancelled.";
            return result;
        }
    },

    generateInvoice: async function(id) {
        const url = 'main/transaction/receipt64/'+id
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {})
            return ApiService.validateResponse(response, '0519')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    modifyTransaction: async function(transactionData) {
        // var today = new Date();
        // var dd = String(today.getDate()).padStart(2, '0');
        // var MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        // var yy = today.getFullYear().toString().substr(-2);
        // var todayNew = MM + dd + yy;
        const randVal = await ApiService.getRandomValue();
        var secretKeyOTP  = process.env.VUE_APP_OPSTK+randVal;
        var encryptedOTP = CryptoAES.encrypt(secretKeyOTP, ApiService.getFormData("otp"));

        console.log("TRX DATA", transactionData);

        //console.log("MODIFY DETAILS : "+transactionData.transactionTypeId+" ## "+transactionData.deliveryMethodId+" ## "+transactionData.bankTypeId)
        let isWallet       = (transactionData.transactionTypeId == 2 && transactionData.deliveryMethodId == 1 && transactionData.bankTypeId == 2) ? true : false
        let accountNumber = (transactionData.bankAccountNo != undefined && transactionData.bankAccountNo >0) ? transactionData.bankAccountNo : ""
        if(isWallet){
            
            if(transactionData.homeCountryId == 167){ // exclude countryIDD for PH (DR-1438)
                accountNumber = transactionData.walletNo == undefined ? "" : transactionData.walletNo
            }else{
                accountNumber = transactionData.walletNo == undefined ? "" : transactionData.homeCountryIdd.substring(1) + transactionData.walletNo
            }
            
        }

        let idType     = (transactionData.deliveryMethodId == 3
            && (transactionData.homeCountryId == 18 || transactionData.homeCountryId == 98 || transactionData.homeCountryId == 197))
        ? transactionData.idTypeSelect
        : transactionData.identificationType;

        const trxAddress = {

            streetAddress                   : encodeURIComponent((transactionData.street != undefined && transactionData.street != "") ? transactionData.street : ""),
            postcode                        : (transactionData.postcode != undefined && transactionData.postcode != "") ? transactionData.postcode : "",
            cityId                          : 0,
            city                            : "",
            provinceId                      : 0,
            province                        : "",
            provinceCode                    : "",
            countryId                       : transactionData.homeCountryId,
            country                         : transactionData.homeCountryName,
            countryISOCode2                 : "",
            countryISOCode3                 : "",
            buildingNumber                  : encodeURIComponent(transactionData.locatingNote),
            streetName                      : encodeURIComponent((transactionData.street != undefined && transactionData.street != "") ? transactionData.street : ""),
            buildingName                    : encodeURIComponent(transactionData.landmark),
            unitNumber                      : encodeURIComponent(transactionData.locatingNote),

        }


        const params = {
            transactionId                       : transactionData.transactionId,
            beneficiaryName                     : encodeURIComponent(transactionData.beneficiaryFullName),
            beneficiaryHomePhone                : transactionData.homeNo,
            beneficiaryMobilePhone              : transactionData.mobileNo,
            email                               : encodeURIComponent(transactionData.email),
            paymentPurpose                      : encodeURIComponent((transactionData.paymentPurposeId == -1) ? transactionData.paymentPurposeOther : transactionData.paymentPurpose),
            accountNo                           : accountNumber, //(transactionData.bankAccountNo != undefined && transactionData.bankAccountNo >0) ? transactionData.bankAccountNo : "",
            refNo                               : encodeURIComponent((transactionData.refNo != undefined && transactionData.refNo != "") ? transactionData.refNo : ""),
            cashCardNo                          : (transactionData.bankAccountNo != undefined && transactionData.bankAccountNo >0 && transactionData.deliveryMethodId == 6) ? transactionData.bankAccountNo : "",
            bankAccountName                     : encodeURIComponent((transactionData.bankAccountName != undefined && transactionData.bankAccountName != "") ? transactionData.bankAccountName : ""),
            beneficiaryHomePhoneCountryId       : transactionData.homeIDD,
            beneficiaryMobilePhoneCountryId     : transactionData.mobileIDD,
            beneficiaryTypeId                   : (transactionData.beneficiaryTypeId != undefined) ? transactionData.beneficiaryTypeId : 0,
            beneficiaryIdNumber                 : encodeURIComponent((transactionData.identificationNo != undefined) ? transactionData.identificationNo : ""),
            beneficiaryIdType                   : encodeURIComponent((idType != undefined) ? idType : ""),
            updateBene                          : true,
            address                             : trxAddress,

        }

        console.log("PARAMS", params)


        ApiService.setCustomHeader(5, TokenService.getToken(), encodeURIComponent(encryptedOTP));

        const url = 'main/transaction/modify'

        try {
            await ApiService.generateAuthClient(randVal);
            const response = await ApiService.post(url, params)
            return response.data;
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    createPhilGovRemittance: async function(homeAmount,hostAmount,transactionCharges,couponCode,totalAmountPayable,paymentPurpose) {
        ApiService.setHeader()
        let axiosHeader = {
            headers: {
                'Content-Type'                : 'application/json;charset=UTF-8',
                "Authorization"               : `Bearer ${TokenService.getToken()}`
            }
        };

        var params = {
            beneficiaryId     : store.state.transaction.beneficiaryId,
            homeAmount        : homeAmount,
            startMonth        : store.state.transaction.startMonth+ 1, // month 1-12
            startYear         : store.state.transaction.startYear,
            endMonth          : store.state.transaction.endMonth+ 1, // month 1-12
            endYear           : store.state.transaction.startYear,
            mp2               : store.state.transaction.mp2No,
            loanNumber        : store.state.transaction.loanNumber,
            flexiFund         : store.state.transaction.flexiFund,
            prn               : store.state.transaction.prnNo,
            philGovAmount     : homeAmount,
            branchId          : store.state.transaction.bankBranchId,

            retailBranchId    : store.state.misc.appBranchId,
            hostAmount        : hostAmount,
            transactionCharges: transactionCharges,
            couponCode        : couponCode,
            totalAmountPayable: totalAmountPayable,
            additionalFee     : '',
            paymentPurpose    : paymentPurpose
        }

        console.log("params createPhilGovRemittance : ", params)

        const url = 'main/philgov'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.customHeader(url, params, axiosHeader)
            console.log(response)
            const resTransaction = response.data

            return resTransaction
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }

    },

    validatePhilGov: async function(params) {
        const url = 'main/validate/philgov'
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.post(url, params)
            return response.data
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e;
            }
        }
    },

    getPhilGovContributionlist: async function() {
        const url = 'main/philgov/contributionlist'
        const params = {
            memberTypeId : 0,
            startMonth   : 0,
            startYear    : 0,
            endMonth     : 0,
            endYear      : 0,
        }
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            return ApiService.validateResponse(response, '11244')
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    getPhilGovePaymentList: async function(params, bankBranchId) {
        const url = 'main/philgov/payment/' + bankBranchId
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            return response.data
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

    checkingRouting: async function(bankId, beneficiaryId, homeAmount) {
        const url = 'main/routing/' + beneficiaryId
        const params = {
            bankId     : bankId,
            homeAmount : homeAmount
        }
        try {
            await ApiService.generateAuthClient();
            const response = await ApiService.get(url, {params})
            return response.data
        } catch(e) {
            console.log(e)
            if(e instanceof GenericError) {
                throw e
            }
        }
    },

}

export default TransactionService